import { render, staticRenderFns } from "./DataChart.vue?vue&type=template&id=52301808&scoped=true&"
import script from "./DataChart.vue?vue&type=script&lang=js&"
export * from "./DataChart.vue?vue&type=script&lang=js&"
import style0 from "./DataChart.vue?vue&type=style&index=0&id=52301808&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52301808",
  null
  
)

export default component.exports